import React from 'react';
import { Activity } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function MechanismReveal() {
  return <section className="py-14 bg-slate-900 relative overflow-hidden" data-id="element-561">
      {/* Glow effect behind the reveal */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-96 bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-562" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-563">
        <ScrollFadeIn data-id="element-564">
          <Activity className="w-12 h-12 text-amber-500 mx-auto mb-8" data-id="element-565" />
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.1} data-id="element-566">
          <h2 className="text-4xl md:text-5xl font-serif text-slate-50 mb-8 leading-tight" data-id="element-567">
            The secret isn't more discipline;
            <br data-id="element-568" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-569">
              it's Vagal Braking.
            </span>
          </h2>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.2} data-id="element-570">
          <p className="text-xl text-slate-300 leading-relaxed mb-8 max-w-3xl mx-auto" data-id="element-571">
            The Vagus Nerve is the "Yellow Brake Line" of your nervous system.
            By using physiological "switches"—specific breathing ratios,
            temperature shifts, and strategic nighttime nutrition—you can
            manually force your body out of Fight-or-Flight and into
            Rest-and-Burn mode.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.3} data-id="element-572">
          <div className="inline-block border border-amber-500/30 bg-amber-500/10 px-8 py-4 rounded-lg" data-id="element-573">
            <p className="text-amber-400 font-medium text-lg tracking-wide" data-id="element-574">
              When the survival signal stops, the fat-storage stops.
            </p>
          </div>
        </ScrollFadeIn>
      </div>
    </section>;
}